export default __webpack_public_path__ + "static/lawyer-test-a50da6439f549d64d7b51497d72f9bf0.png";